import React from 'react';
import { Link } from 'react-router-dom';
import { blogData } from '../data/blogData';
import SafeIcon from '../common/SafeIcon';
import { FiArrowRight, FiCalendar } from 'react-icons/fi';

const Blog = () => {
  return (
    <div className="min-h-screen bg-[#f4f4f4] py-12 md:py-20 px-6">
      <div className="max-w-6xl mx-auto">
        <header className="mb-16 text-center md:text-left">
          <h1 className="text-5xl md:text-7xl font-black uppercase tracking-tighter leading-none mb-4">
            THE <span className="bg-black text-white px-2">ETERA</span> BLOG
          </h1>
          <p className="text-xl font-bold text-gray-500 uppercase tracking-tight">
            Insights on permanent links, QR tech, and digital ownership.
          </p>
        </header>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {blogData.map((post) => (
            <article 
              key={post.id} 
              className="bg-white border-4 border-black p-8 brutal-shadow flex flex-col brutal-hover"
            >
              <div className="flex items-center gap-2 text-xs font-black uppercase text-gray-400 mb-4">
                <SafeIcon icon={FiCalendar} className="w-3 h-3" />
                {post.date}
              </div>
              
              <h2 className="text-2xl font-black uppercase mb-4 leading-tight group-hover:text-blue-600 transition-colors">
                {post.title}
              </h2>
              
              <p className="font-bold text-gray-600 mb-8 flex-grow leading-relaxed">
                {post.excerpt}
              </p>
              
              <Link 
                to={`/blog/${post.slug}`}
                className="inline-flex items-center gap-2 font-black uppercase text-sm border-b-4 border-black pb-1 hover:text-blue-600 hover:border-blue-600 transition-all w-fit"
              >
                Read More <SafeIcon icon={FiArrowRight} className="w-4 h-4" />
              </Link>
            </article>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Blog;